const scrollTop = (time = 500) => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, time)
}

export default scrollTop
